export default () => ({
  scoped: {
    backgroundColor: 'transparent',
  },
});
